import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b1d486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "days" }
const _hoisted_2 = { class: "day" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "hi-lo-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℉")
], -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℃")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℉")
], -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℃")
], -1))
const _hoisted_18 = { class: "extended__precip-container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "extended__precip-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12,20A6,6 0 0,1 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14A6,6 0 0,1 12,20Z" })
], -1))
const _hoisted_20 = { class: "extended__future-featured-precip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.item && _ctx.weather.location)
    ? (_openBlock(), _createElementBlock("div", {
        id: "outer-container",
        class: "outer-container",
        key: _ctx.liveRevision,
        style: _normalizeStyle({ background: _ctx.item.backgroundColor })
      }, [
        _createElementVNode("main", {
          style: _normalizeStyle({ color: _ctx.item.fontColor })
        }, [
          _createElementVNode("h1", {
            style: _normalizeStyle({ color: _ctx.item.fontColor })
          }, _toDisplayString(_ctx.weather.location.name) + ", " + _toDisplayString(_ctx.weather.location.region), 5),
          _createElementVNode("section", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weather.forecast.forecastday, (forecastday, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "day__container",
                key: index
              }, [
                _createElementVNode("h2", {
                  style: _normalizeStyle({ color: _ctx.item.fontColor }),
                  class: "line-heading"
                }, _toDisplayString(_ctx.getDayOfWeek(forecastday.date)), 5),
                _createElementVNode("article", _hoisted_2, [
                  (forecastday.day.daily_chance_of_rain)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        style: _normalizeStyle({ height: forecastday.day.daily_chance_of_rain + '%' }),
                        class: "precipitation-progress"
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createElementBlock("svg", {
                    fill: _ctx.weatherIconKey[forecastday.day.condition.code].fill,
                    class: "day__icon",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      d: _ctx.weatherIconKey[forecastday.day.condition.code].icon
                    }, null, 8, _hoisted_4)
                  ], 8, _hoisted_3)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "hi-lo__arrow",
                        style: _normalizeStyle({ fill: _ctx.item.fontColor }),
                        viewBox: "0 0 24 24"
                      }, _hoisted_7, 4)),
                      (_ctx.isFahrenheit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(Math.floor(forecastday.day.maxtemp_f)), 1),
                            _hoisted_9
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(Math.floor(forecastday.day.maxtemp_c)), 1),
                            _hoisted_11
                          ]))
                    ]),
                    _createElementVNode("div", null, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "hi-lo__arrow",
                        style: _normalizeStyle({ fill: _ctx.item.fontColor }),
                        viewBox: "0 0 24 24"
                      }, _hoisted_13, 4)),
                      (_ctx.isFahrenheit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createTextVNode(_toDisplayString(Math.floor(forecastday.day.mintemp_f)), 1),
                            _hoisted_15
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(Math.floor(forecastday.day.mintemp_c)), 1),
                            _hoisted_17
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(Math.floor(forecastday.day.daily_chance_of_rain) + '%'), 1)
                  ]),
                  _createElementVNode("p", {
                    class: "day__summary",
                    style: _normalizeStyle({ color: _ctx.item.fontColor })
                  }, _toDisplayString(forecastday.day.condition.text), 5)
                ])
              ]))
            }), 128))
          ])
        ], 4)
      ], 4))
    : _createCommentVNode("", true)
}